import { useAuth } from "../contexts/AuthProvider";
import { FEATURE_FLAGS } from "../contexts/FeatureFlagsProvider";
import { useFeatureFlag } from "./useOpenFeatureFlag";

export function useSaveAsDefaultEnabled(): boolean {
	const { userInfo } = useAuth();
	return useFeatureFlag(FEATURE_FLAGS.SaveAsDefaultEnabled) || userInfo.support;
}
